import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Initialize i18n before App
import './i18n/config'
// DB Theme styles - order matters!
import '@db-ux/db-theme/build/styles/index.css'
import '@db-ux/core-foundations/build/styles/icons/rollup.css'
import '@db-ux/db-theme-fonts/build/styles/rollup.css'
import '@db-ux/db-theme-icons/build/styles/rollup.css'
// App styles
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
